'use strict'

require '../../src/frontend/helper/general/m_googleTagManager'

require './common/underscore_mixins'
window.Hogan = require 'hogan.js'
require './groupon_modules/groupon'
require '../../modules/gig_body/header/search_bar/frontend/desktop_searchbar'
require '../../src/frontend/helper/lazyLoadImages'
require './groupon_modules/performance'

LSTouch = require '../../modules/gig_body/header/frontend/views/ls_touch'
PNHeaderV2 = require '../../modules/gig_body/header/frontend/views/pn_header_v2'
stickyHeader = require '../../modules/gig_body/header/frontend/sticky_header'
inAppMessage = require '../../modules/in_app_messages/frontend/main'
require '../../modules/gig_body/components/back2top/frontend/main'
require '../../modules/doubleclick/frontend/doubleclick'
require './groupon_modules/verifyUserCookies'
{User} = require '../../modules/gig_body/header/usernav/frontend/setup_user'
uncommentThirdPartyAssets = require './groupon_modules/uncommentThirdPartyAssets'
gcxFlyout = require '../../modules/gig_body/header/sub_nav/frontend/init_flyout'
{ incognitoTest } = require '../../src/frontend/helper/incognito'
{ initCllTimer } = require '../../src/frontend/helper/search/helper/m_detectCurrentLocation'
{ setELLFromSearchLoc } = require '../../src/frontend/helper/search/helper/m_location_helper'
{ getCardatronCards } = require '../../modules/service_calls/frontend/getCardatronCards'
{ cookieBanner } = require '../../modules/cookie_banner/frontend/main'
incognitoTest('desktop')


setELLFromSearchLoc() # set ELL from searchLoc cookie

$ ->
  _removeInvalidCookies()
  cookieBanner()
  # When < 600px (mobile), change the viewport meta tag to disable user scaling.
  # This prevents unnecessary zooming when focusing on inputs and is an alternative to
  # setting the font size of the inputs to 16px (which Apple recommends for iOS Safari).
  mMax = Groupon.LS.mediaQueries.mMax
  if Groupon.LS.hasTouch and matchMedia?(mMax).matches
    $(document.head).find('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')

  Groupon.Utils.lazyLoadImages()
  LSTouch.init()

  if ($header = $('.header-v2')).length
    Groupon.Modules.Header = new PNHeaderV2 $header

  User.init()

  $('body').removeClass 'no-js'
  OptimizeSuite.initBloodhound() unless Optimize.delayBloodhound

  # Add handler for back link on responsive header
  $('a.t-back-link').not('[href]').on 'click', ->
    history.back()

  # The click handler is required to help trigger the educational flyout, when the user clicks on
  # the search promotion widget for getaways
  # The search promotion widget now comes via megamind.
  $('.getaways-tab-flyout [data-bhc$="ga-search"]').click ->
    Cookie.unset 'flyOut_shown', '.groupon.com'
    Cookie.unset 'flyOut_shown' # belts and suspenders (if app forgot .domain)

  # Enable CPP get started link in the main user navigation menu if user
  # has a "has_cpp" cookie, which is set when user visits /u/get-started once.
  # Link should also be displayed if user is participating in AB experiment.
  # This is a "temporary" solution and might be lifted later after launch.
  if Cookie.get('has_cpp') in ['1', 'true']
    $('#user-my-page').removeClass 'hidden'

  $("#subscribe_modal_container")?.trigger 'launchSubsUIModal'

  # Kick off flyout handlers (no-op when element doesn't exist)
  gcxFlyout.init()

$(window).on 'load', ->
  if Optimize.delayBloodhound
    setTimeout (->
      OptimizeSuite.initBloodhound()
    ), 100

  initCllTimer()


  Groupon.Utils.lazyLoadImages({threshold: 200}, '.lazy-wl')
  new Groupon.Widgets.BackToTopButton
  inAppMessage.init()

  if $('.header-v2').length
    # LS-2925 init after window load, so the page has already scrolled to it's cached position.
    stickyHeader.init('search')

  Groupon.verifyUserCookies()

  uncommentThirdPartyAssets()

  if Groupon?.LS?.flags?.useCardatronNavCards
    getCardatronCards()

  if Groupon?.LS?.data?.appName is 'deal'
    Finch?.experiment("LS-3080-AADealPageBucketing", {
      Control: ->
        # Nothing
      Treatment: ->
        # Nothing
    })

  return

_removeInvalidCookies = ->
  rootDomain = document.head.getAttribute('data-domain') # .groupon.com
  return unless /^\.groupon\./i.test(rootDomain)

  Cookie.unset 'search_loc', rootDomain
  Cookie.unset 'division' # www.groupon.com



// WEBPACK FOOTER //
// ./core/frontend/sls-vVERSION.coffee